import { c as _c } from "react/compiler-runtime";
import { QueryKeys } from "@/constants/queryKeys";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { searchGeoLocationApiAction } from "../actions/actions";
export const GEOLOCATION_QUERY_KEYS = {
  all: [QueryKeys.GEOLOCATION_QUERY],
  getGeolocation: (query: string) => [...GEOLOCATION_QUERY_KEYS.all, query]
};
export function getGeolocationQueryOptions(query: string) {
  return queryOptions({
    queryKey: GEOLOCATION_QUERY_KEYS.getGeolocation(query),
    queryFn: () => searchGeoLocationApiAction(query),
    enabled: !!query && query.length > 2
  });
}
export const useGeolocation = query => {
  const $ = _c(2);
  let t0;
  if ($[0] !== query) {
    t0 = getGeolocationQueryOptions(query);
    $[0] = query;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};